import { atom } from 'jotai';

export const isCompleteVisibleAtom = atom<boolean>(false);

export const imageAtom = atom<string>('');

export const nameAtom = atom<string>('');

export const agreedAtom = atom<boolean>(false);
